import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import RadioButtonGroup from '@material-ui/core/RadioGroup';
import RadioButton from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid'
import { connect } from "react-redux";
import { compose } from "redux";
import { registrationAction } from "../actions/SessionAction";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Sentry } from 'react-activity';
import 'react-activity/dist/react-activity.css';
// import IconButton from '@material-ui/core/IconButton';
// import PhotoCamera from '@material-ui/icons/PhotoCamera';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
// import Chip from '@material-ui/core/Chip';
// import Avatar from '@material-ui/core/Avatar';
function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const { innerWidth } = window;


const styles = theme => ({
    paper: {
        position: 'absolute',
        // width: theme.spacing.unit * 100,
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        // padding: '10px 32px 10px 32px',
        outline: 'none',
        borderRadius: 5
    },
    stepperClass: {
        padding: innerWidth >= 480 ? theme.spacing.unit * 2 : 0,
    },
    input: {
        display: 'none',
      },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    img: {
        width: 330,
        height: 300,
        marginLeft: 220
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },
    gradientButton: {
        
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        },
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
      },
    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 350,
        // marginTop: -1,
        // marginLeft: 8
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // width: `calc(100% - ${theme.spacing.unit * 2}px)`
        margin: 0
    },
    inputStyle1: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
        // textTransform: "capitalize"
    },
    inputStyled: {
        padding: '13px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    textField1: {
        width: 720,
        marginTop: -1,
        marginLeft: 8
    },
    updatebutton: {
        background: '#2cc676',
        margin: theme.spacing.unit,
        height: 30,

        color: 'white',
        textAlign: "center"
    }
});

function getSteps() {
    return ['Library Register', 'Librarian Register', 'Completed'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return '';
        case 1:
            return '';
        case 2:
            return '';
        default:
            return '';
    }
}

class LibraryRegistration extends Component {
    constructor() {
        super();
        this.state = {
            open: false,
            activityIndicatorProcess: false,
            library_name: "",
            library_phone: "",
            library_email: "",
            website_url: "",
            interested_in_stem: null,
            state_or_county: "",
            nextPage: false,
            activeStep: 0,
            confirm_password: "",
            password: "",
            first_name: "",
            last_name: "",
            selected_library_image_name:"",
            selected_librarian_image_name:"",
            email: "",
            user_type: "LIBRARIAN",
            displayCloseButton: true,
            registerError: "",
            registerSuccess: "",
            statuses: "",
            library_image: null,
            user_image: null
        };
    }

    librarySubmition = () => {
        let isError = false;
        if (this.state.first_name === "") {
            this.setState({ first_name_error: true })
            isError = true
        }
        if (this.state.last_name === "") {
            this.setState({ last_name_error: true })
            isError = true
        }

        if (this.state.email !== null && this.state.email !== "") {
            if (!this.validateEmail(this.state.email) === true) {
                this.setState({ invaild_email_error: true })
                isError = true
            }
        } else {
            isError = true
            this.setState({ email_error: true })

        }
        if (this.state.password !== null && this.state.password !== "") {
            if (!(this.state.password.length >= 8)) {
                this.setState({ invalid_password_error: true })
                isError = true
            }
        } else {
            this.setState({ password_error: true })
            isError = true
        }

        if (this.state.confirm_password !== null && this.state.confirm_password !== "") {
            if (!(this.state.password === this.state.confirm_password)) {
                this.setState({ invalid_confirm_password_error: true })
                isError = true
            }
        } else {
            this.setState({ confirm_password_error: true })
            isError = true
        }
        if (isError === false) {
            this.props.dispatch(registrationAction(this, this.state));
            if(this.state.statuses !== "success"){

            
            this.setState({
                open: true,
                // library_name: "",
                // library_primary_contact_name: "",
                // library_primary_contact_email: "",
                // library_phone: "",
                // library_email: "",
                // website_url: "",
                // interested_in_stem: null,
                // state_or_county: "",
                // library_name_error: false,
                // library_primary_contact_name_error: false,
                // library_primary_contact_email_error: false,
                // library_email_error: false,
                // interested_in_stem_error: false,
                // invaild_library_email_error: false,
                // invaild_library_primary_contact_email_error: false,
                // invaild_website_url: false,
                activeStep: 2,
                // first_name: "",
                // last_name: "",
                // email: "",
                // password: "",
                // selected_library_image_name:"",
                // selected_librarian_image_name:"",
                // confirm_password: "",
                // first_name_error: false,
                // last_name_error: false,
                // email_error: false,
                // password_error: false,
                // confirm_password_error: false,
                // invalid_password_error: false,
                // invaild_email_error: false,
                // invalid_confirm_password_error: false,
                // library_image: null,
                // user_image: null
            });
        }else{
            this.setState({
                open: true,
                library_name: "",
                library_primary_contact_name: "",
                library_primary_contact_email: "",
                library_phone: "",
                library_email: "",
                website_url: "",
                interested_in_stem: null,
                state_or_county: "",
                library_name_error: false,
                library_primary_contact_name_error: false,
                library_primary_contact_email_error: false,
                library_email_error: false,
                interested_in_stem_error: false,
                invaild_library_email_error: false,
                invaild_library_primary_contact_email_error: false,
                invaild_website_url: false,
                activeStep: 2,
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                selected_library_image_name:"",
                selected_librarian_image_name:"",
                confirm_password: "",
                first_name_error: false,
                last_name_error: false,
                email_error: false,
                password_error: false,
                confirm_password_error: false,
                invalid_password_error: false,
                invaild_email_error: false,
                invalid_confirm_password_error: false,
                library_image: null,
                user_image: null
            });
        }
        }
    }

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    libraryRegister = () => {

        let isError = false;
        if (this.state.library_name === "") {
            this.setState({ library_name_error: true })
            isError = true
        }
        if(this.state.library_phone !== ""){
            if (this.state.library_phone.length >= 10 ) {
                if (!this.validatePhone(this.state.library_phone) === true) {
                this.setState({ library_phone_error: true });
                isError = true
            }
            }
            else {
                this.setState({ library_phone_error: true });
                isError = true  
            }
        }
        
        if (this.state.library_email === "") {
            this.setState({ library_email_error: true })
            isError = true
        }
        if (this.state.interested_in_stem === null) {
            this.setState({ interested_in_stem_error: true })
            isError = true
        }
        if (this.state.website_url !== null && this.state.website_url !== "") {
            if (!this.validateUrl(this.state.website_url) === true) {
                this.setState({ invaild_website_url: true })
                isError = true
            }
        }

        // if (this.state.library_primary_contact_name === "") {
        //     this.setState({ library_primary_contact_name_error: true })
        //     isError = true
        // }
        // if (this.state.library_primary_contact_email !== null && this.state.library_primary_contact_email !== "") {
        //     if (!this.validateEmail(this.state.library_primary_contact_email) === true) {
        //         this.setState({ invaild_library_primary_contact_email_error: true })
        //         isError = true
        //     }
        // } else {
        //     isError = true
        //     this.setState({ library_primary_contact_email_error: true })

        // }
       
        if (isError === false) {

            this.setState({
                open: true,
                activeStep: 1
            });
        }
    }
    handleChangeApproval = (event) => {
        this.setState({ interested_in_stem: event.target.value, interested_in_stem_error: false })
    };
    // handleChangeRadio = (event) => {
    //     this.setState({ state_or_county: event.target.value });
    // };

    handleClose = () => {
        this.setState({
            open: false,
            library_name: "",
            library_primary_contact_name: "",
            library_primary_contact_email: "",
            library_phone: "",
            library_email: "",
            website_url: "",
            selected_library_image_name:"",
            selected_librarian_image_name:"",
            interested_in_stem: null,
            state_or_county: "",
            library_name_error: false,
            library_primary_contact_name_error: false,
            library_primary_contact_email_error: false,
            library_email_error: false,
            interested_in_stem_error: false,
            invaild_library_email_error: false,
            invaild_library_primary_contact_email_error: false,
            activeStep: 0,
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            confirm_password: "",
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            password_error: false,
            confirm_password_error: false,
            invalid_password_error: false,
            invaild_email_error: false,
            invalid_confirm_password_error: false,
            displayCloseButton: true,
            library_image: null,
            user_image: null
        });
    };
    validateEmail(email) {

        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    validateUrl(url) {
        // console.log("-------------"+JSON.stringify(url))
        var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        return re.test(url);
    }
    validatePhone(phone) {
        // console.log("-------------"+JSON.stringify(url))
            // console.log("-------------"+JSON.stringify(url))
            var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/
            return re.test(phone);
    }
    
    libraryImage = ({ target }) => {
        // const fileReader = new FileReader();
        // const name = target.accept.includes('image') ? 'images' : 'videos';

        // fileReader.readAsDataURL(target.files[0]);
        // fileReader.onload = (e) => {
        //     this.setState((prevState) => ({
        //         [name]: [...prevState[name], e.target.result]
        //     }));
        // };
        this.setState({ library_image: target.files[0],selected_library_image_name: target.files[0].name});
        // console.log(JSON.stringify(this.state.library_image))
    };

    librarianImage = ({ target }) => {
        // const fileReader = new FileReader();
        // const name = target.accept.includes('image') ? 'images' : 'videos';

        // fileReader.readAsDataURL(target.files[0]);
        // fileReader.onload = (e) => {
        //     this.setState((prevState) => ({
        //         [name]: [...prevState[name], e.target.result]
        //     }));
        // };
        this.setState({ user_image: target.files[0],selected_librarian_image_name: target.files[0].name});
    };

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep } = this.state;
        return (
            <div style={{ marginTop: 10 }}>
                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={this.handleOpen}>Register Library !</Button>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        {(this.state.displayCloseButton && <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>)}
                        <Stepper activeStep={activeStep} className={classes.stepperClass}>
                            {steps.map(label => (
                                <Step key={label}>
                                    <StepLabel ><span style={{ fontSize: 14 }}>{label}</span></StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <div>
                            {this.state.activeStep === steps.length - 3 ? (
                                <div>
                                    <Grid container spacing={8}>
                                        <Grid item xs={12} style={{ marginTop: 15 }}>
                                            <FormLabel component="legend" required style={{ fontSize: "14px", color: 'black' }} error={this.state.interested_in_stem_error === true ? true : false}>
                                                Is the library interested in learning more about STEM learning exchange program ?
                                            </FormLabel>
                                            <RadioButtonGroup defaultValue={this.state.interested_in_stem} onChange={this.handleChangeApproval} row >
                                                <FormControlLabel value="Yes" control={<RadioButton />} label="Yes" />
                                                <FormControlLabel value="No" control={<RadioButton />} label="No" />
                                            </RadioButtonGroup>
                                            <FormHelperText error> {this.state.interested_in_stem_error === true ? "Please select Yes/No in interested STEM" : false} </FormHelperText>
                                        </Grid>
                                        <Grid item xs={12} >                                            
                                            <FormLabel component="legend" style={{ fontSize: "14px", color: 'black' }}>
                                                If the library is a branch of state/county wide network state which one (e.g. Sacramento library )?
                                            </FormLabel>
                                            <TextField
                                                id="standard-name"
                                                // label="If the library is a branch of state/county wide network state which one (e.g. Sacramento library )?"
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.state_or_county}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                
                                                onChange={(event) => 
                                                    {
                                                        let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                                        this.setState({ state_or_county: value })
                                                    }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="standard-name"
                                                label="Library name"
                                                required
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.library_name}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                helperText={this.state.library_name_error === true ? "Please enter library name" : false}
                                                error={this.state.library_name_error === true ? true : false}
                                                onChange={(event) =>
                                                    {
                                                        let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                                        this.setState({ library_name: value, library_name_error: false })}
                                                    
                                                    }
                                            />
                                        </Grid>

                                        <Grid item xs={6} >
                                            <TextField
                                                id="standard-name"
                                                label="Library phone"
                                                fullWidth
                                                // type="number"
                                                className={classes.textField}
                                                value={this.state.library_phone}
                                                onChange={(event) => this.setState({ library_phone: event.target.value, library_phone_error: false })}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                helperText={this.state.library_phone_error === true ? "Please enter valid phone number" : false}
                                                error={this.state.library_phone_error === true ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="standard-name"
                                                label="Library mailing address"
                                                required
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.library_email}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                helperText={this.state.library_email_error === true ? "Please enter mailing address " : false}
                                                error={this.state.library_email_error === true ? true : false}
                                                onChange={(event) => 
                                                    {
                                                        let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                                        this.setState({ library_email: value, library_email_error: false})
                                                    }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="standard-name"
                                                label="Library website URL"
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.website_url}
                                                onChange={(event) => this.setState({ website_url: event.target.value, invaild_website_url: false })}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                error={this.state.invaild_website_url === true ? true : false}
                                                helperText={this.state.invaild_website_url === true ? "Please enter valid website url" : null}
                                            />
                                        </Grid>
                                        <Grid item xs={12} >                                                
                                            <input
                                                accept="image/*"
                                                className={classes.input}
                                                id="contained-button-file"
                                                type="file"
                                                onChange={this.libraryImage}
                                            />
                                            <label htmlFor="contained-button-file">
                                                <Button variant="outlined" component="span" className={classes.gradientButton}>
                                                Upload library image
                                                <CloudUploadIcon className={classes.rightIcon} />
                                                </Button>
                                            </label>
                                            <Typography>{this.state.selected_library_image_name}</Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <div style={{ textAlign: "center" }}>
                                                <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                                    cancel
                                                </Button>
                                                <Button variant="contained" size="small" className={classes.button} onClick={this.libraryRegister}>
                                                    Next
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            ) : this.state.activeStep === steps.length - 2 ? (
                                <div>
                                    <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                                    <Grid container spacing={16}>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="stan"
                                                label="First name"
                                                required
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.first_name}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                helperText={this.state.first_name_error === true ? "Please enter first name" : false}
                                                error={this.state.first_name_error === true ? true : false}
                                                onChange={(event) => 
                                                    {
                                                    let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                                    this.setState({ first_name: value, first_name_error: false });
                                                    }
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="dard-name"
                                                label="Last name"
                                                required
                                                fullWidth
                                                className={classes.textField}
                                                value={this.state.last_name}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                helperText={this.state.last_name_error === true ? "Please enter last name" : false}
                                                error={this.state.last_name_error === true ? true : false}
                                                onChange={(event) => 
                                                    {
                                                        let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                                        this.setState({ last_name: value, last_name_error: false })
                                                    }
                                                }
                                            />
                                        </Grid>

                                        <Grid item xs={12} >
                                            <TextField
                                                id="stand"
                                                label="Email"
                                                required
                                                fullWidth
                                                // className={classes.textField1}
                                                value={this.state.email}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle1 } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                error={this.state.email_error === true ? true : this.state.invaild_email_error === true ? true : false}
                                                helperText={this.state.email_error === true ? "Please enter email address" : this.state.invaild_email_error === true ? "Please enter valid email address" : null}
                                                onChange={(event) => this.setState({ email: event.target.value, email_error: false, invaild_email_error: false })}
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="standard"
                                                label="Password"
                                                type="password"
                                                required
                                                fullWidth
                                                //className={classes.textField}
                                                value={this.state.password}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                error={this.state.password_error === true ? true : this.state.invalid_password_error === true ? true : false}
                                                helperText={this.state.password_error === true ? "Please enter password" : this.state.invalid_password_error === true ? "Please enter vaild password" : false}
                                                onChange={(event) => this.setState({ password: event.target.value, password_error: false, invalid_password_error: false })}
                                            />
                                        </Grid>
                                        <Grid item xs={6} >
                                            <TextField
                                                id="name"
                                                type="password"
                                                label="Confirm Password"
                                                required
                                                fullWidth
                                                //className={classes.textField}
                                                value={this.state.confirm_password}
                                                margin="normal"
                                                InputProps={{ classes: { input: classes.inputStyle } }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    FormLabelClasses: {
                                                        root: classes.labelRoot
                                                    }
                                                }}
                                                
                                                error={this.state.confirm_password_error === true ? true : this.state.invalid_confirm_password_error === true ? true : false}
                                                helperText={this.state.confirm_password_error === true ? "Please enter confirm password" : this.state.invalid_confirm_password_error === true ? "Please enter same password" : null}
                                                onChange={(event) => this.setState({ confirm_password: event.target.value, confirm_password_error: false, invalid_confirm_password_error: false })}

                                            />
                                        </Grid>
                                        <Grid item xs={12} >                                            
                                             <input
                                                    accept="image/*"
                                                    className={classes.input}
                                                    id="contained-button-file"
                                                    type="file"
                                                    onChange={this.librarianImage}
                                                />
                                                <label htmlFor="contained-button-file">
                                                    <Button variant="contained" component="span" className={classes.gradientButton}>
                                                    Upload librarian image
                                                    <CloudUploadIcon className={classes.rightIcon} />
                                                    </Button>
                                                </label>
                                                <Typography>{this.state.selected_librarian_image_name}</Typography>

                                        </Grid>
                                    </Grid>
                                    <div style={{ textAlign: "center" }}>
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={this.handleBack}
                                            variant="contained" color="secondary" size="small" className={classes.cancelbutton}                >
                                            Back
                                        </Button>
                                        <Button variant="contained" size="small" className={classes.button} onClick={this.librarySubmition}>
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            ) :
                                    (this.state.activityIndicatorProcess ?
                                        <div style={{ textAlign: "center" }}>
                                            <Sentry style={{ textAlign: "center" }} color="green" size={90} speed={1} animating={this.state.activityIndicatorProcess} />
                                        </div>
                                        : (this.state.statuses === "success" ?
                                            <div>                                                
                                                <center style={{ color: "green", fontSize: 20 }}>
                                                    {"Thank you for registering with ThunderBots. You will receive notification as email after your application has been approved."}
                                                </center>
                                            </div>
                                            :
                                            <div>   
                                                 <center style={{ color: "red", fontSize: 20 }}>                                                
                                                    {/* {"Your registration is failed !"} */}
                                                    {this.state.registerError}
                                                </center>
                                            <Grid item xs={12} >
                                            <div style={{ textAlign: "center",paddingTop: 50 }}>
                                            <Button
                                                disabled={activeStep === 1}
                                                onClick={this.handleBack}
                                                variant="contained" style={{backgroundColor:"blue",color:"white"}} size="small" className={classes.cancelbutton}                >
                                                Back
                                            </Button> 
                                            <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                                cancel
                                            </Button>
                                               
                                            </div>
                                            </Grid>
                                                                                       
                                               
                                            </div>
                                        )
                                    )
                                }
                        </div>
                    
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registerError: state.SessionReducer.registerError,
        registerSuccess: state.SessionReducer.registerSuccess
    }
}
LibraryRegistration.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), connect(mapStateToProps))(LibraryRegistration);